import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: "isCurrentUser",
})
export class IsCurrentUserPipe implements PipeTransform {

    constructor() {
    }

    transform(id: number): boolean {
        return abp.session.userId === id
    }

}
